var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube_full-color_icon_(2017)",
    clipPath: "url(#clip0_180_508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.1814 2.86366C25.8836 1.76238 25.0245 0.900019 23.9232 0.605474C22.4439 0.0343828 8.11592 -0.245435 3.95956 0.621837C2.85829 0.919656 1.99592 1.77875 1.70138 2.88002C1.03374 5.80911 0.983014 12.1418 1.71774 15.1364C2.01556 16.2377 2.87465 17.1 3.97592 17.3946C6.90501 18.0687 20.8305 18.1637 23.9396 17.3946C25.0408 17.0967 25.9032 16.2377 26.1977 15.1364C26.9096 11.9455 26.9603 6.00547 26.1814 2.86366Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1632 8.99999L11.4868 5.1709V12.8291L18.1632 8.99999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0182,
    height: 18,
    fill: "white",
    transform: "translate(0.981445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.4b1e26a7c247788d3ff3811c9c6c1d03.svg";
export { ForwardRef as ReactComponent };